import { createContext } from 'react';
import type { AccountType, ClientBalanceCategoryDto } from '../../api/generated/client';
import type { NavigationTabTotalWealth } from '../../enums';
import type { IMap } from '../../interfaces/generic';
import type { IWealthChartData } from '../../interfaces/wealth';

export interface IWealthContextValues {
    partnerUid?: string;
    clientCurrency?: string;
    activeBalanceCategory?: ClientBalanceCategoryDto;
    setActiveCategoryId: (categoryId: number) => void;
    setActiveAccountType: (accountType: AccountType) => void;
    onTabClicked: (tab: NavigationTabTotalWealth) => void;
    activeTab: NavigationTabTotalWealth;
    activeCategoryId: number;
    wealthChartDataMap: IMap<IWealthChartData | undefined>;
    activeAccountType?: AccountType;
}

/**
 * Context for storing wealth and balance-sheet related data.
 * @type {Context<IWealthContextValues | null>}
 */
export const wealthContext = createContext<IWealthContextValues | null>(null);
